import { Component, OnInit } from "@angular/core";
import { Helper } from "app/shared/helpers/helper";
import { ConnectService } from "../connect.service";

@Component({
    selector: 'server-not-responding',
    templateUrl: './server-not-responding.component.html',
    styleUrls: ['./server-not-responding.component.scss']
})

export class ServerNotResponding implements OnInit {

    serverNotRespondingText: string = 'No momento, nossos serviços estão passando por manutenção. Por favor, tente novamente mais tarde.';
    APIISNOTRESPONDING = false;

    constructor(
        private connectService: ConnectService
    ){}

    ngOnInit(): void {
        this.testApiConnection();
    }
    
    async testApiConnection() {
        try {
          const response = await this.connectService.isOperating().toPromise();
          const result = Helper.deserialize(response.text());
          this.APIISNOTRESPONDING = result.DbConnection !== 'Ok';
        } catch (error) {
          this.APIISNOTRESPONDING = true;
        }
    }
}


// WEBPACK FOOTER //
// ./src/app/login/shared/server-not-responding/server-not-responding.component.ts